import { shequRequestGet } from '@/services/shequ_request';

// 获取职位列表
export const apiGetJobList = (params: { job?: number }) => {
  const newparams = { ...params, perpage: 3 };
  return shequRequestGet('/v1/job/joblist/', newparams);
};
